import { Text } from '@chakra-ui/react';
import { PatchDataWrapper } from '@diamond/shared/data-access';
import {
  BackofficeActivitiesOrderItem,
  BackofficeOrderUpdate,
} from '@diamond/shared/types';
import { QueryKey } from '@tanstack/react-query';

import {
  useUpdateActivitiesDetailColumn,
  useUpdateActivitiesDetailQueryData,
} from '../../../hooks';
import { EditableColumnProps } from '../../../types/activity-column-types';

const API_URL = 'backoffice/order';

interface Props
  extends EditableColumnProps<
    BackofficeActivitiesOrderItem,
    string | null | undefined
  > {
  queryKey?: QueryKey;
  activitiesId: string;
  token?: string;
  refetch: () => void;
}

export function NoteColumn({
  info,
  selectedData,
  onUpdate,
  queryKey = [],
  activitiesId,
  token,
  refetch,
}: Props) {
  const { patchData } = PatchDataWrapper<BackofficeOrderUpdate>(
    API_URL,
    token as string,
    'admin'
  );

  const isSelected = selectedData.some(
    (row) => row.original.id === info.row.original.id
  );

  // Optimistic update for query cache
  const setQueryData = useUpdateActivitiesDetailQueryData({
    queryKey,
    info,
    name: 'note',
  });

  // Debounced update handler (allowEmpty: true because notes can be empty)
  const setValue = useUpdateActivitiesDetailColumn({
    onUpdate(value) {
      setQueryData(value);
      patchData(
        { note: value },
        undefined,
        `${activitiesId}/item/${info.row.original.id}`
      ).then(async () => {
        refetch();
      });
    },
    allowEmpty: true,
  });

  if (isSelected) {
    const noteValue = info.getValue() ?? '';
    return (
      <div className="px-1">
        <input
          key={`note-${info.row.original.id}-${noteValue}`}
          style={{
            borderColor: 'gray',
            borderWidth: 1,
            borderRadius: 4,
            padding: 4,
          }}
          className={'cursor-pointer'}
          type="text"
          defaultValue={noteValue}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    );
  }

  return (
    <Text fontSize="sm" fontWeight="400" color="#373F41">
      {info.getValue() ?? '-'}
    </Text>
  );
}
